export default __webpack_public_path__ + "static/media/telegramDeskMobile.17e6cb30.svg";